import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from '../config';
import { displayNameForItem } from '../../domain/equipment';
import { createSaveStore } from '../../persistence/saveStore';
import { createDefaultPermanentSave } from '../../persistence/schema';
import { paintInteriorBackdrop } from '../village/art';
import {
  addBackToVillageButton,
  addSecondaryButton,
  titleBlock,
} from '../ui/hubUi';

/**
 * Blacksmith foundation — permanent equipment collection or honest empty state.
 * Management lives on Hero (M7-A); no crafting invented here.
 */
export class BlacksmithScene extends Phaser.Scene {
  constructor() {
    super('Blacksmith');
  }

  create(): void {
    const cx = GAME_WIDTH / 2;
    const g = this.add.graphics();
    paintInteriorBackdrop(g, GAME_WIDTH, GAME_HEIGHT, 0x3a2a22, 0x2a1e18);

    const forge = this.add.circle(cx, 200, 28, 0xff6b35, 0.9);
    this.tweens.add({
      targets: forge,
      scale: 1.15,
      alpha: 0.55,
      duration: 500,
      yoyo: true,
      repeat: -1,
    });
    this.add
      .rectangle(cx, 250, 72, 18, 0x5a4030)
      .setStrokeStyle(2, 0x3a2a20);

    addBackToVillageButton(this);
    titleBlock(
      this,
      'Blacksmith',
      'Permanent equipment vault. Equip on the Hero tab.',
      300,
    );

    const store = createSaveStore();
    const permanent =
      store.load()?.permanent ?? createDefaultPermanentSave();
    const gear = permanent.equipment;

    this.add
      .text(
        cx,
        370,
        `Gold ${permanent.currency.gold}  ·  Materials ${permanent.currency.materials}`,
        {
          fontFamily: 'system-ui, sans-serif',
          fontSize: '13px',
          color: '#c9a227',
        },
      )
      .setOrigin(0.5);

    if (gear.length === 0) {
      this.add
        .text(
          cx,
          430,
          'No equipment banked yet.\nClear a dungeon to keep run loot permanently.',
          {
            fontFamily: 'system-ui, sans-serif',
            fontSize: '14px',
            color: '#9aa3c0',
            align: 'center',
            wordWrap: { width: GAME_WIDTH - 48 },
            lineSpacing: 6,
          },
        )
        .setOrigin(0.5);
    } else {
      const preview = gear.slice(0, 8);
      preview.forEach((item, i) => {
        this.add
          .text(cx, 410 + i * 24, `• ${displayNameForItem(item)}`, {
            fontFamily: 'system-ui, sans-serif',
            fontSize: '13px',
            color: '#f2e6c8',
          })
          .setOrigin(0.5);
      });
      if (gear.length > preview.length) {
        this.add
          .text(cx, 410 + preview.length * 24, `…and ${gear.length - preview.length} more`, {
            fontFamily: 'system-ui, sans-serif',
            fontSize: '12px',
            color: '#6e7694',
          })
          .setOrigin(0.5);
      }
    }

    addSecondaryButton(
      this,
      cx,
      GAME_HEIGHT - 120,
      'Open Hero Equipment',
      () => {
        this.scene.start('Hero');
      },
      280,
    );
  }
}
